import { useTranslation } from 'react-i18next';

import { Header } from '../components/index.jsx';
import { useViewport } from '../hooks';
import { BreakpointMobile } from '../constants/ui';
import { Scoring } from '../components/Scoring/index.jsx';
import { getSidebarLinksMap } from '../utils/ui';

const ScoringPage = () => {
  const { widthViewport } = useViewport();
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  return (
    <>
      {widthViewport > BreakpointMobile && <Header title={SidebarLinksMap.scoring.title} t={t} />}
      <main className="main">
        <Scoring t={t} />
      </main>
    </>
  );
};

export default ScoringPage;
